import {
  Avatar,
  Box,
  Paper,
  Skeleton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors, fonts, size } from "../../ColorFont/color";
import EditHrsPopup from "./EditHrsPopup";
import { Edit, History, Visibility } from "@mui/icons-material";
import { url } from "../../ConstUrl/Url";

const ListSellers = () => {
  const [sellers, setSellers] = useState([]); // State to store the list of sellers
  const [loading, setLoading] = useState(true); // State to handle loading state
  const [error, setError] = useState(null); // State to handle errors
  const [plots, setPlots] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedSellerId, setSelectedSellerId] = useState(null);
  const [username, setUsername] = useState([]);
  const [openEditHrsPopup, setOpenEditHrsPopup] = useState(false);
  const [openPlansHistory, setOpenPlansHistory] = useState(false);
  const [sellerPlanPurchaseHistory, setSellerPlanPurchaseHistory] = useState([]);
  const handleEditHrs = async (sellerId, hrs) => {
    try {
      const response = await fetch(`${url}/api/users/edit-hrs/${sellerId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sponseredHours: hrs,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to edit hours");
      }
      alert("Hours updated successfully!");
      refetchSellers(); // Refetch sellers data after editing hours
    } catch (error) {
    }
  };

  const handleViewPlansHistory = async (sellerId) => {
    try {
      const response = await fetch(
        `${url}/api/users/${sellerId}/seller-plan-purchase-history`
      );
      const data = await response.json();
      const sellerPlanPurchaseHistory = data.sellerPlanPurchaseHistory;

      // Display the seller plan purchase history in a dialog or table
      setOpenPlansHistory(true);
      setSellerPlanPurchaseHistory(sellerPlanPurchaseHistory);
    } catch (error) {
    }
  };

  const handleEditHrsClick = (sellerId) => {
    setSelectedSellerId(sellerId);
    setOpenEditHrsPopup(true);
  };
  const refetchSellers = async () => {
    try {
      const response = await fetch(`${url}/api/users/seller`);
      if (!response.ok) {
        throw new Error("Failed to fetch sellers");
      }
      const data = await response.json();
      setSellers(data); // Update the sellers state with the fetched data
    } catch (error) {
      setError(error.message); // Set error message if something goes wrong
    }
  };
  // Fetch sellers from the backend
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const response = await fetch(`${url}/api/users/seller`);
        if (!response.ok) {
          throw new Error("Failed to fetch sellers");
        }
        const data = await response.json();
        setSellers(data); // Update the sellers state with the fetched data
      } catch (error) {
        setError(error.message); // Set error message if something goes wrong
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchSellers();
  }, []);

  const handleViewPlots = async (sellerId) => {
    setSelectedSellerId(sellerId);
    setOpen(true);
    try {
      const response = await fetch(
        `${url}/api/users/get-user-by-id/${sellerId}`
      );
      const data = await response.json();
      const plots = data.plotsAdded;
      setUsername(data.firstName);
      setPlots(plots);
    } catch (error) {
    }
  };

  // Display loading state
  if (loading) {
    return (
      <Box sx={{ margin: "20px" }}>
        <Skeleton
          variant="text"
          sx={{ width: 300, height: 40, marginBottom: 5 }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              width: "28%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
            }}
          >
            <Paper
              elevation={4}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
            </Paper>

            <Paper
              elevation={4}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
            </Paper>

            <Paper
              elevation={4}
              sx={{
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
            </Paper>
          </Box>
        </Box>
      </Box>
    );
  }

  // Display error message if there's an error
  if (error) {
    return <div>Error: {error}</div>;
  }

  // Display the list of sellers
  return (
    <Box>
      <Box sx={{ margin: "14px" }}>
        <Typography
          sx={{
            fontFamily: fonts.poppins,
            fontSize: size.title,
            color: colors.primary_dark,
            fontWeight: 600,
            marginBottom: 4,
          }}
        >
          Seller Lists
        </Typography>
        {sellers.length > 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{ 
                borderRadius: 3, 
                border: `1px solid ${colors.border}`,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)"
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Profile
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Contact
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Address
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      No Of Hours
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sellers.map((seller, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Avatar />
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {seller.firstName} {seller.lastName}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {seller.email}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {seller.phoneNumber}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {seller.state}, {seller.country}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {seller.sponseredHours}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Tooltip title="Edit">
                            <Edit
                              sx={{ color: colors.primary_dark }}
                              onClick={() => handleEditHrsClick(seller._id)}
                            />
                          </Tooltip>
                          <Tooltip title="Added Plots">
                            <Visibility
                              sx={{ color: colors.primary_dark }}
                              onClick={() => handleViewPlots(seller._id)}
                            />
                          </Tooltip>
                          <Tooltip title="Plan History">
                            <History
                              sx={{ color: colors.primary_dark }}
                              onClick={() => handleViewPlansHistory(seller._id)}
                            />
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <Typography sx={{ fontFamily: fonts.poppins }}>
            No sellers found.
          </Typography>
        )}
      </Box>
      <Box>
        <Dialog
          open={openPlansHistory}
          onClose={() => setOpenPlansHistory(false)}
        >
          <DialogTitle
            sx={{
              fontFamily: fonts.poppins,
              fontSize: size.title,
              fontWeight: 600,
              color: colors.primary_dark,
            }}
          >
            Seller Plan Purchase History
          </DialogTitle>
          <DialogContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}
                  >
                    Plan Name
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}
                  >
                    Original Price
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}
                  >
                    Discounted Price
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}
                  >
                    Sponsored Hours
                  </TableCell>
                  <TableCell
                    sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}
                  >
                    Purchase Date
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sellerPlanPurchaseHistory.map((plan) => (
                  <TableRow key={plan.planId}>
                    <TableCell sx={{ fontFamily: fonts.poppins }}>
                      {plan.name}
                    </TableCell>
                    <TableCell sx={{ fontFamily: fonts.poppins }}>
                      {plan.originalPrice}
                    </TableCell>
                    <TableCell sx={{ fontFamily: fonts.poppins }}>
                      {plan.discountedPrice}
                    </TableCell>
                    <TableCell sx={{ fontFamily: fonts.poppins }}>
                      {plan.sponseredHrs}
                    </TableCell>
                    <TableCell sx={{ fontFamily: fonts.poppins }}>
                      {plan.purchaseDate}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundImage: colors.button, fontFamily: fonts.poppins }}
              onClick={() => setOpenPlansHistory(false)}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <EditHrsPopup
        open={openEditHrsPopup}
        onClose={() => {
          setOpenEditHrsPopup(false);
          refetchSellers();
        }}
        selectedSellerId={selectedSellerId}
        handleEditHrs={handleEditHrs}
      />
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            fontFamily: fonts.poppins,
            fontWeight: 600,
            fontSize: size.title,
            color: colors.primary_dark,
          }}
        >
          Plots Added by {username}
        </DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Category
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Country
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  State
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Taluka
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Village
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Amount
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Photos
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                  Contact Number
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plots.map((plot) => (
                <TableRow key={plot._id}>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.category}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.country}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.state}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.taluka}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.village}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.amount}
                  </TableCell>
                  <TableCell>
                    {plot.photos.map((photo) => (
                      <img src={photo} alt="Plot Photo" />
                    ))}
                  </TableCell>
                  <TableCell sx={{ fontFamily: fonts.poppins }}>
                    {plot.contactNumber}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundImage: colors.button, fontFamily: fonts.poppins }}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ListSellers;
